import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { useCart } from "../../context/CartContext";
import { money } from "../../lib/api";
import { variantPrice } from "../../lib/categories";
import { ColorPicker, SizePicker, unavailableSizes, unavailableColors, firstColor } from "./VariantPicker";

export const QuickAddDialog = ({ p, open, onOpenChange }) => {
  const { add } = useCart();
  const [color, setColor] = useState(firstColor(p));
  const [size, setSize] = useState(p.sizes?.length === 1 ? p.sizes[0] : null);
  const submit = () => add(p, color, size) && onOpenChange(false);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="rounded-3xl max-w-md" data-testid={`quick-add-dialog-${p.slug}`}>
        <div className="flex gap-4">
          <img src={p.images?.[0]} alt={p.name} className="w-24 h-24 rounded-2xl object-cover" />
          <div>
            <DialogTitle className="text-navy text-lg leading-snug">{p.name}</DialogTitle>
            <p className="font-bold text-navy mt-1">{money(size ? variantPrice(p, color, size) : p.price)}</p>
          </div>
        </div>
        <ColorPicker colors={p.colors} unavailable={unavailableColors(p)} value={color} onChange={(c) => { setColor(c); if (unavailableSizes(p, c).includes(size)) setSize(null); }} />
        <div>
          <p className="text-sm font-semibold text-navy mb-2">Size</p>
          <SizePicker sizes={p.sizes} value={size} onChange={setSize} unavailable={unavailableSizes(p, color)} />
        </div>
        <button
          disabled={!size || unavailableSizes(p, color).includes(size)}
          onClick={submit}
          className="w-full h-14 rounded-full bg-sun text-navy font-extrabold disabled:opacity-40 hover:bg-[#ffe34d] transition-colors"
          data-testid="quick-add-submit"
        >
          {size ? "Add to Cart" : "Select a size"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
